import { useEffect, useState } from "react";

/**
 * Floating "back to the top" button.
 *
 * The mission board sends visitors deep into the page; without a way back they are left
 * scrolling blind. This appears once the board is off-screen and returns to it in one tap.
 */
export function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    function onScroll() {
      setVisible(window.scrollY > 500);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;
  return (
    <button
      className="back-to-top"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="맨 위로"
    >
      ⬆️ 처음으로
    </button>
  );
}
